<template>
  <div :id="id"
       class="o-echarts">

  </div>
</template>

<script>
// import echarts from 'echarts'
import * as echarts from 'echarts'
import moment from 'moment'
let chart = null
export default {
  name: 'ProvinceInsurancePayChart',
  props: {
    id: {
      type: String,
      required: false,
      default: 'provinceInsurancePayChart'
    },
    subtext: {
      type: String,
      required: false,
      default: moment().format('YYYY年MM月DD日') + '（左应付 右实付）'
    }
  },
  data () {
    return {
      // id: 'provinceInsurancePayChart',//地图渲染容器id
      option: {
        title: {
          text: '',
          subtext: '2020年04月26日（左应付 右实付）',
          left: 'right',
          top: -15
        },
        tooltip: {
          trigger: 'axis'
        },
        dataset: {
          // dimensions: ['organization', '中央财政', '省财政', '县财政', '个人'],
          // source: [
          //   { organization: '阳光保险', '中央财政': 1000, '省财政': 1500, '县财政': 1200, '个人': 1289, '中央财政': 1000, '省财政': 1500, '县财政': 1200, '个人': 1289 },
          //   { organization: '太平洋保险', '中央财政': 2000, '省财政': 1800, '县财政': 1600, '个人': 1000, '中央财政': 2000, '省财政': 1800, '县财政': 1600, '个人': 1000 },
          //   { organization: '安信保险', '中央财政': 5000, '省财政': 2000, '县财政': 3000, '个人': 1489, '中央财政': 5000, '省财政': 2000, '县财政': 3000, '个人': 1489 },
          //   { organization: '华安保险', '中央财政': 10000, '省财政': 5000, '县财政': 8000, '个人': 1600, '中央财政': 10000, '省财政': 5000, '县财政': 8000, '个人': 1600 },
          // ]
        },
        dataZoom: [{
          type: 'slider',
          show: false, // flase直接隐藏图形
          xAxisIndex: [0],
          left: '9%', // 滚动条靠左侧的百分比
          bottom: -5,
          start: 0, // 滚动条的起始位置
          end: 50 // 滚动条的截止位置（按比例分割你的柱状图x轴长度）
        }],
        legend: {
          top: 16,
          // left: 10,
          itemGap: 10,
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            color: '#333'
          },
          icon: 'rect'
          // selected:{
          //   '个人应付':false,
          //   '中央财政应付':false,
          //   '县财政应付':false,
          //   '省财政应付':false
          // },
          //  data: ["中央财政", "省财政", "县财政", "个人"]
        },
        grid: {
          left: 50,
          right: 10
        },
        toolbox: {
          show: true
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            // data: ["阳光保险 ", "太平洋保险", "安信保险", "华安保险"],
            axisTick: {
              show: false

            },
            axisLine: {
              lineStyle: {
                color: '#aaa',
                type: 'dotted'
              }
            },
            axisLabel: {
              // interval: 0,
              // rotate: 30,
              color: '#333',
              rotate: 20
            }

          }
        ],
        yAxis: [
          {
            type: 'value',
            axisTick: {
              show: false
            },
            splitLine: {
              lineStyle: {
                type: 'dotted'
              }
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              formatter (val) {
                if (val >= 10000) {
                  return val / 10000 + '万'
                } else return val
              }
            }
          }
        ],
        color: ['#1a8dee', '#58bdf4', '#2bfffe', '#46f383'],
        series: [
          {
            type: 'bar',
            stack: '应付',
            barWidth: 14,
            name: ''
            // data: [1000, 2000, 5000, 10000]
          },
          {
            type: 'bar',
            stack: '应付',
            barWidth: 14,
            name: ''
            // data: [1000, 2000, 5000, 10000]
          },
          {
            type: 'bar',
            stack: '应付',
            barWidth: 14,
            name: ''
            // data: [1000, 2000, 5000, 10000],
          },
          {
            type: 'bar',
            stack: '应付',
            barWidth: 14,
            name: ''
            // data: [1000, 2000, 5000, 10000],
          },
          {
            type: 'bar',
            stack: '实付',
            barWidth: 14,
            name: ''
            // data: [1500, 1800, 3000, 5000]
          },
          {
            type: 'bar',
            stack: '实付',
            barWidth: 14,
            name: ''
            // data: [2000, 2800, 800, 2400]
          },
          {
            type: 'bar',
            stack: '实付',
            barWidth: 14,
            name: ''
            // data: [1400, 1000, 700, 1200]
          },
          {
            type: 'bar',
            stack: '实付',
            barWidth: 14,
            name: ''
            // data: [1400, 1000, 700, 1200]
          }
        ]

      }
    }
  },
  mounted () {
    // this.initMap()

  },
  watch: {

  },
  methods: {
    listenResize () {
      // 窗口改变大小
      if (chart) {
        chart.resize()
      }
    },
    initMap (optionData) {
      // 设置时间
      if (optionData.date) {
        this.option.title.subtext = optionData.date || ''
      }
      if (optionData.dataZoom) {
        this.option.dataZoom[0].show = optionData.dataZoom
      }
      this.option.dataset = optionData.dataset || []
      chart = echarts.init(
        document.getElementById(this.id)
      )
      chart.setOption(this.option)
      if (optionData.chartHeight) {
        chart.resize({ height: optionData.chartHeight })
      } else {
        chart.resize({ height: 300 })
      }
    }

  },
  components: {

  }
}
</script>

<style scoped lang="less">
.o-echarts {
  min-width: 30px;
  min-height: 30px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/homechart/ProvinceInsurancePayChart.vue